import styled from "styled-components";

export const Main = styled.main`
  margin: auto;
  width: 100%;
  max-width: 1000px;
  padding: 20px;
  img {
    display: block;
    margin: auto;
  }
.Outputmu {
	font-size: 0.95rem;	
};
`;
